import { CommonModule } from '@angular/common';
import { Component, NgModule } from '@angular/core';

/**
 * Leyenda de estados de tickets (servicio + gestión).
 * Misma UI que Ticketería; se reutiliza en Programación → Tickets.
 */
@Component({
  selector: 'app-tickets-status-legend',
  templateUrl: './tickets-status-legend.component.html',
  styleUrls: ['./tickets-status-legend.component.css']
})
export class TicketsStatusLegendComponent {}

@NgModule({
  declarations: [TicketsStatusLegendComponent],
  imports: [CommonModule],
  exports: [TicketsStatusLegendComponent]
})
export class TicketsStatusLegendModule {}
